"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.animationStart = exports.animationEnd = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _variables = _interopRequireDefault(require("./variables"));
// See https://github.com/daneden/animate.css/issues/644
var animationStart = exports.animationStart = function (el) {
  var animation = {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart'
  };
  for (var t in animation) {
    if (el.style[t] !== undefined) {
      return animation[t];
    }
  }
}(window.document.createElement('div'));
var animationEnd = exports.animationEnd = function (el) {
  var animation = {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd'
  };
  for (var t in animation) {
    if (el.style[t] !== undefined) {
      return animation[t];
    }
  }
}(window.document.createElement('div'));
var animationStyles = {
  '@global': (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "@keyframes ".concat(_variables.default.fadeIn), {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  }), "@keyframes ".concat(_variables.default.fadeOut), {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0
    }
  })
};
var _default = exports.default = animationStyles;
//# sourceMappingURL=animationStyle.js.map